import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
} from "@mui/material";
import { DialogProps } from "./types";

export interface AlertDialogPayload {
  msg: React.ReactNode;
  title?: React.ReactNode;
  okText?: React.ReactNode;
}

export type AlertDialogProps = DialogProps<AlertDialogPayload, void>;

const AlertDialog = ({ open, payload, onClose }: AlertDialogProps) => {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{payload.title ?? "Alert"}</DialogTitle>
      <DialogContent>{payload.msg}</DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>{payload.okText ?? "OK"}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
